import ConstructionIcon from '@mui/icons-material/Construction'
import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

export default function WeTrack() {
  const { t } = useTranslation()

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        opacity: 0.6,
      }}
    >
      <ConstructionIcon style={{ fontSize: 100, marginBottom: 5 }} />
      <Typography align={'center'} variant="h4" sx={{ marginBottom: '10px' }}>
        {t('products.inConstruction')}
      </Typography>
    </Box>
  )
}
